import styled from '@emotion/styled'
import { Layout } from 'components/atoms'

export const Container = styled(Layout)`
    display: grid;
    gap: 2rem;
    max-height: 450px;
    overflow-y: auto;
`

export const Header = styled(Layout)`
    position: sticky;
    top: 0;
    background-color: var(--chakra-colors-white);
    z-index: 1;
`
